import { render, staticRenderFns } from "./printHKPurchase.vue?vue&type=template&id=6ddf7ffa&scoped=true&"
import script from "./printHKPurchase.vue?vue&type=script&lang=js&"
export * from "./printHKPurchase.vue?vue&type=script&lang=js&"
import style0 from "./printHKPurchase.vue?vue&type=style&index=0&id=6ddf7ffa&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddf7ffa",
  null
  
)

component.options.__file = "printHKPurchase.vue"
export default component.exports